import { decamelizeKeys } from 'humps'
import request from '@/utils/request'

const transformValue = (value) => {
  if (TypeChecker.isObject(value)) {
    return JSON.stringify(value)
  }

  return value
}

const convertToFormData = (data) => {
  const form = new FormData()

  Object.entries(data).forEach(([key, value]) => {
    form.append(key, transformValue(value))
  })

  return form
}

class API {
  constructor(uri, fetcher = request) {
    this.uri = uri
    this.fetcher = fetcher
  }

  transformData = (data, options = {}) => {
    const { decamelize = true, useFormData = false } = options
    const transformedData = decamelize ? decamelizeKeys(data) : data

    return useFormData ? convertToFormData(transformedData) : transformedData
  }
}

export default API
